const router = {
    path: 'order',
    name: 'order',
    component: resolve => require(['../../views/order/index.vue'], resolve),
    meta: {
        requireAuth: true,
        keepAlive: false,
        title: '订单管理',
        level: 1
    },
    children: []
}

export default router



// WEBPACK FOOTER //
// ./src/router/module/order.js